module.exports = __webpack_public_path__ + "1eb21360e5c2cb7aa946249e5aa049f8.gif";